import { __ } from '@wordpress/i18n';
import { useState } from '@wordpress/element';
import { Filter, WpDatePicker } from '@dokan/components';
import SearchBar from './SearchBar';
import { dateI18n, getSettings } from '@wordpress/date';
import { SimpleInput } from '@getdokan/dokan-ui';
import { Calendar1 } from 'lucide-react';

interface QuoteFilterProps {
    search: string;
    isLoading: boolean;
    isItemAvailable: boolean;
    setSearch: ( value: string ) => void;
    setCurrentStatus: ( value: string ) => void;
    quotedDate: string;
    setQuotedDate: ( date: string ) => void;
}

const QuoteFilter = ( {
    search,
    setSearch,
    isLoading,
    isItemAvailable,
    setCurrentStatus,
    quotedDate,
    setQuotedDate,
}: QuoteFilterProps ) => {
    const [ localSearch, setLocalSearch ] = useState( search );
    const [ localDate, setLocalDate ] = useState< string >( quotedDate );

    const handleSearchChange = ( value: string ) => {
        setLocalSearch( value );
    };

    const getCurrentDate = () => {
        if ( localDate ) {
            const d = new Date( localDate );
            return isNaN( d.getTime() ) ? new Date() : d;
        }
        return new Date();
    };

    const getDisplayDate = () => {
        if ( localDate ) {
            try {
                return dateI18n(
                    getSettings().formats.date,
                    localDate,
                    getSettings().timezone.string
                );
            } catch ( error ) {
                return '';
            }
        }
        return '';
    };

    return (
        <Filter
            className="pb-2"
            namespace="quote_list_filters"
            fields={ [
                <SearchBar
                    key="search_bar"
                    search={ localSearch }
                    setSearch={ handleSearchChange }
                    isLoading={ isLoading }
                    isItemAvailable={ isItemAvailable }
                />,
                <WpDatePicker
                    key="date_filter"
                    onChange={ ( date ) =>
                        setLocalDate( date?.split( 'T' )[ 0 ] )
                    }
                    currentDate={ getCurrentDate() }
                >
                    <SimpleInput
                        value={ getDisplayDate() }
                        addOnRight={
                            <span className="truncate max-w-[20rem] max-h- inline-block">
                                <Calendar1 size={ 20 } />
                            </span>
                        }
                        className="bg-white focus:bg-white shadow-none focus:shadow-none text-sm max-w-40 border-tr-0 border-br-0 px-4"
                        input={ {
                            type: 'text',
                            placeholder: __( 'Select Date', 'dokan' ),
                            readOnly: true,
                        } }
                    />
                </WpDatePicker>,
            ] }
            showFilter={ true }
            showReset={ true }
            onFilter={ () => {
                setSearch( localSearch );
                setQuotedDate( localDate );
            } }
            onReset={ () => {
                setLocalSearch( '' );
                setSearch( '' );
                setQuotedDate( '' );
                setCurrentStatus( 'all' );
            } }
        />
    );
};

export default QuoteFilter;
